import React from 'react';
import ReactDOM from 'react-dom/client';
import { FlutterEmbedding } from 'counter-embedding-react';
import App from './App/App';
import './index.css';
import reportWebVitals from './reportWebVitals';

await FlutterEmbedding.startEngine().catch((error: any) => {
  console.error('Failed to start Flutter engine:', error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
